export const inputStyle = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 0,
    backgroundColor: '#f7f8fa',
    transition: 'all 0.2s ease',
    '& fieldset': {
      borderColor: '#dce1e8',
      transition: 'border-color 0.2s ease',
    },
    '&:hover fieldset': {
      borderColor: '#0063a6',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#0063a6',
      borderWidth: 2,
    },
    '& input:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 1000px #f7f8fa inset',
      WebkitTextFillColor: '#313131',
      transition: 'background-color 5000s ease-in-out 0s',
    },
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#0063a6',
  },
};

export const buttonStyle = {
  backgroundColor: '#0063a6',
  color: '#fff',
  borderRadius: 0,
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '1rem',
  padding: '12px 32px',
  boxShadow: 'none',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: '#94c11c',
    boxShadow: '0 4px 16px rgba(148, 193, 28, 0.3)',
  },
};
